import { createSelector } from 'reselect';

import { filtersSelector } from '../root/filtersSelector';

export const businessAppointmentsSelector = createSelector(filtersSelector, filters => filters.businessAppointments);
